import * as moment from 'moment';

export class HistoricoReprovacao {
  public justificativa: string;
  public reprovadoPor: string;
  public dataReprovacao: Date;
  public dataReprovacaoFormatada: string;

  constructor(model?: any) {
    if (model) {
      Object.assign(this, model);
      this.reprovadoPor = model?.usuarioResponsavel;
      this.dataReprovacao = model?.dataValidacao
        ? new Date(model.dataValidacao) : null;
        
      this.dataReprovacaoFormatada = model?.dataValidacao
        ? moment(model.dataValidacao).format('DD/MM/YYYY [às] HH:mm')
        : '';
    }
  }
}
